import React, { useContext, useRef, useState } from "react";
import "./AddChatRoomModal.css";
import { IoCloseOutline, IoDocumentTextOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { GrAttachment } from "react-icons/gr";
import { CgCloseO } from "react-icons/cg";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { GeneralContext } from "../../../../GeneralProvider";

export default function AddChatRoomModal({
    isOpen,
    onClose,
    selectedChannel
}) {
    const { getTranslation } = useLanguage();
    const { handleCreateRoom } = useContext(GeneralContext);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [roomTitle, setRoomTitle] = useState();
    const [description, setDescription] = useState();
    const [isPrivate, setIsPrivate] = useState(false);
    const [onlyAdminText, setOnlyAdminText] = useState(false);
    const fileInputRef = useRef();

    if (!isOpen) return null;

    const resetStates = () => {
        setSelectedFiles([])
        setRoomTitle("")
        setDescription("")
        setIsPrivate(false)
        setOnlyAdminText(false)
    }

    const onComplete = async () => {
        const createdRoom = await handleCreateRoom(
            selectedChannel.channelID,
            roomTitle,
            description,
            true,
            !onlyAdminText
        );

        if (createdRoom) {
            resetStates();
            onClose(createdRoom); // ✅ yeni oda objesini üst component'e gönder
        }
    };

    const handleOnClose = () => {
        resetStates()
        onClose()
    }

    return (
        <div className="add-room-modal-overlay">
            <div className="add-room-modal-container">
                <IoCloseOutline
                    className="add-room-modal-button close"
                    onClick={handleOnClose}
                />

                <p className="add-room-modal-title">{getTranslation("createRoom")}</p>

                <span
                    className="add-channel-modal-title"
                    style={{
                        alignItems: "center",
                        gap: "15px",
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "500",
                        fontSize: "14px",
                    }}
                >
                    {getTranslation("onlyAdminsCanSendMessage")}
                    <input
                        type="checkbox"
                        checked={onlyAdminText}
                        onChange={() => setOnlyAdminText(!onlyAdminText)}
                    />
                </span>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("roomName") + "*"}
                    value={roomTitle}
                    onChange={(e) => setRoomTitle(e.target.value)}
                    type={"text"}
                />

                <div className="add-task-modal-content">
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className="add-task-modal-textarea"
                        placeholder={getTranslation("description")}
                        value={description}
                        rows={6}
                        onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                </div>

                <div className="add-room-modal-actions">
                    <button
                        onClick={onComplete}
                        className="add-room-modal-button create"
                    >
                        {getTranslation("create")}
                    </button>
                </div>
            </div>
        </div>
    );
}
